import { countTypeEnum, OperationTypeEnum, ProductionProcessTypeEnum, spsaOperationEnum, spsaPrevOperationEnum } from '@gtpl/shared-models/common-models';
import { OPERATION_FIELDS, prodOpCreateReq, prodOpReq } from '@gtpl/shared-models/production-management';
import { OperationService, ProdlogService } from '@gtpl/shared-services/production';
import { Button, Card, Col, DatePicker, Form, Input, message, Row, Select } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { ProductService } from 'libs/shared-services/masters/src/lib/products-service';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
const { Option } = Select;

const SpsaProductionOperationsForm = () => {
  const [form] = Form.useForm();

  const productionService = new ProdlogService();

  const [lotNumbers, setLotNumbers] = useState<any[]>([]);
  const [prevOp, setPrevOp] = useState<string>('prev Operation');
  const [selectedOperation, setSelectedOperation] = useState<string>('');
  const [qtyInfo, setQtyInfo] = useState<any>(0);
  const [prevOpData,setPrevOpData]=useState<any[]>([]);
  const [prevProduct,setPrevProduct]=useState<any[]>([])
  const plantId=Number(localStorage.getItem("unit_id"));
  const createdUser=JSON.parse(localStorage.getItem('username'));
const [prevCountType,setPrevCountType]=useState<any[]>([])
const [prevCount,setPrevCount]=useState<any[]>([])
const hasCountFields = () => {
  const fields = OPERATION_FIELDS[(selectedOperation).toUpperCase()] || [];
  return fields.some(f => f.name === 'countType');
};
  useEffect(() => {
  if (prevOpData?.length > 0) {
    console.log("setting remarks");
    const data = prevOpData[0];

            if(!form.getFieldValue('remarks')){
            form.setFieldsValue({
                remarks:data.remarks || ''
            });
        }

 form.setFieldsValue({
            lotName:data.variantName || '',
            quality:data.quality || ''
        });
  }
}, [prevOpData]);


    const getPrevOPOutputProduct = () => {
  const req = new prodOpCreateReq();
  req.prevOperation = form.getFieldValue('previousOperation');
  req.lotNumber = form.getFieldValue('lotNumber');

  productionService.getPrevOPOutputProduct(req).then((res) => {
    if (res.status) {
      setPrevProduct(res.data);
      if (res.data.length === 1) {
        const productId = res.data[0].productId;

  form.setFieldsValue({
    variant: productId
  });

  onPrevOpOutputProductChange (productId);
      } else {
        form.setFieldsValue({
          variant: undefined
        });
      }

    } else {
      setPrevProduct([]);
      form.setFieldsValue({ variant: undefined });
      message.error('No Product Found');
    }
  });
};

const getPrevOpOutputCountType=()=>{
    const req=new prodOpCreateReq();
    req.prevOperation=form.getFieldValue('previousOperation');
    req.lotNumber=form.getFieldValue('lotNumber');
    req.prevOpOutProduct=form.getFieldValue('variant')
    productionService.getPrevOpOutputCountType(req).then(res => {
      if(res.status){
        setPrevCountType(res.data);
        if (res.data.length === 1) {
        const value = res.data[0].out_count_type;
        form.setFieldsValue({ countType: value });
        onCountTypeChange(value);
      } else {
        form.setFieldsValue({ countType: undefined });
        setPrevCount([]);
      }
      }else{
        setPrevCountType([]);
      }
    });
  }

const onCountTypeChange = (value) => {
  form.setFieldsValue({ countType: value });
  getPrevOpOutputCount();
};

  const getPrevOpOutputCount=()=>{
    const req=new prodOpCreateReq();
    req.prevOperation=form.getFieldValue('previousOperation');
    req.lotNumber=form.getFieldValue('lotNumber');
    req.prevOpOutProduct=form.getFieldValue('variant')
    req.countType=form.getFieldValue('countType')
    productionService.getPrevOpOutputCount(req).then(res => {
      if(res.status){
        setPrevCount(res.data);
         if (res.data.length === 1) {
        const value = res.data[0].outputCount;
        form.setFieldsValue({ count: value });
        onCountChange(value);
      } else {
        form.setFieldsValue({ count: undefined });
      }
      }else{
        setPrevCount([]);
      }
    });
  }

const onCountChange=(value)=>{
  form.setFieldsValue({ count: value });
  getQtyInfoForInputProdOp();
  getDataAgainstLotForProdOp()
}

  const getDataAgainstLotForProdOp=()=>{
    console.log('API called');
    const req=new prodOpCreateReq();
    req.prevOperation=form.getFieldValue('previousOperation');
    req.lotNumber=form.getFieldValue('lotNumber');
    req.prevOpOutProduct=form.getFieldValue('variant')
    productionService.getDataAgainstLotForProdOp(req).then(res => {
      if(res.status){
        setPrevOpData(res.data);
      }else{
        setPrevOpData([]);
      }
    });
  }

    const getQtyInfoForInputProdOp = () => {
      const req=new prodOpCreateReq();
      req.prevOperation=form.getFieldValue('previousOperation');
      req.operation=form.getFieldValue('operation');
      req.lotNumber=form.getFieldValue('lotNumber');
      req.prevOpOutProduct=form.getFieldValue('variant')
      if(hasCountFields()){
        req.countType=form.getFieldValue('countType')
        req.count=form.getFieldValue('count')
      }
    productionService.getQtyInfoForInputProdOp(req).then(res => {
      if (res.status) setQtyInfo(res.data);
      else setQtyInfo([]);
    });
  };

  const getLotNoForProdOp = () => {
    const req = new prodOpCreateReq();
    req.prevOperation = form.getFieldValue('previousOperation');
    req.operation=form.getFieldValue('operation')
    productionService.getLotNoForProdOp(req).then(res => {
      if (res.status) setLotNumbers(res.data);
      else setLotNumbers([]);
    });
  };

  const onPreviousOperationChange = () => {
    form.setFieldsValue({ lotNumber: undefined });
    getLotNoForProdOp();
    setPrevOp(form.getFieldValue('previousOperation'));
  };

  const onOperationChange = (value: string) => {
    console.log('Selected Operation:', value);
    setSelectedOperation(value.toUpperCase());
    form.resetFields([
      'lotName',
      'variant',
      'quality',
      'quantity',
      'product',
      'count',
    ]);
     setQtyInfo(0);
     setPrevOp(null)
    setLotNumbers([]);
  setPrevProduct([]);
  setPrevCountType([]);
  setPrevCount([]);
  setPrevOpData([]);
    
  };

  const onLotNoChange=()=>{
    getPrevOPOutputProduct()
  }

 const  onPrevOpOutputProductChange=(value)=>{
    setQtyInfo(0);
    form.setFieldsValue({ variant: value });
    if (hasCountFields()) {
    getPrevOpOutputCountType();
  }else{
    getQtyInfoForInputProdOp();
    getDataAgainstLotForProdOp()
  }
 }

const onFinish = async (values: any) => {
  console.log('Form Values:', values);
 const selectedVariant = prevProduct.find( v => v.productId === values.variant);
  const qty = Number( values.quantity);
  const availableQty=Number(qtyInfo?.availableQty)
  if (qty <= 0) {
    message.error('Quantity must be greater than 0');
    return;
  }
  if (qty > availableQty) {
        message.error(`Quantity cannot exceed available qty`);
        return;
      }

  const prevData = prevOpData?.[0] || {};

const processType =
  values.previousOperation === OperationTypeEnum.PACKING
    ? ProductionProcessTypeEnum.REPROCESS
    : prevData.processType;
    
  const req = new prodOpReq();
  req.operation = values.operation;
  req.prevOperation = values.previousOperation;
  req.lotNumber = values.lotNumber;
  req.date = values.date?.toDate();
  req.inputQuantity = qty;
  req.count = values.count;
  req.variantId = values.variant;
  req.quality = prevData.quality;
  req.prodInvId = prevData.prodInvId;
  req.variantName = selectedVariant?.productName;
  req.plantId = plantId; 
  req.createdUser = createdUser; 
  req.remarks=values.remarks;
  req.countType=values.countType;
  req.processType=processType

  console.log('Final Payload:', req);
  const res = await productionService.createLogForProdOp(req);
  
      if (res.status) {
        message.success('Operation Reported successfully');
  
        form.resetFields();
        form.resetFields([
      'lotName',
      'variant',
      'quality',
      'quantity',
      'product',
      'count',
      'remarks'
    ]);
    setSelectedOperation('');
    setQtyInfo(0);
    setPrevOpData([]);
      } else {
         message.error(res.internalMessage,10)
      }
};

  const onReset = () => {
    form.resetFields();
    setSelectedOperation('');
  };

  return (
    <Card
      title={<span style={{ color: 'white' }}>Operation Reporting</span>}
      style={{ textAlign: 'center' }}
      headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
      extra={
        <Button>
          <Link to="/prod-operations">View</Link>
        </Button>
      }
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>

        <Row gutter={16} style={{ marginBottom: 20 }}>
  {/* TOTAL QTY */}
  <Col span={4}>
    <Card
      style={{
        background: '#e6f7ff',
        borderRadius: 10,
        textAlign: 'center'
      }}
      bodyStyle={{ padding: 12 }}
    >
      <div style={{ fontSize: 12, color: '#555', fontWeight: 600 }}>
        {qtyInfo?.reportedType?.toUpperCase()} QTY @ {prevOp?.toUpperCase()}
      </div>
      <div style={{ fontSize: 22, fontWeight: 'bold', color: '#1890ff' }}>
        {qtyInfo?.totalQuantity ?? 0}
      </div>
    </Card>
  </Col>

  {/* CURRENT OP */}
  <Col span={4}>
    <Card
      style={{
        background: '#f6ffed',
        borderRadius: 10,
        textAlign: 'center'
      }}
      bodyStyle={{ padding: 12 }}
    >
      <div style={{ fontSize: 12, color: '#555', fontWeight: 600 }}>
        REPORTED @ {(selectedOperation || 'OPERATION').toUpperCase()}
      </div>
      <div style={{ fontSize: 22, fontWeight: 'bold', color: '#52c41a' }}>
        {qtyInfo?.reportedQuantity ?? 0}
      </div>
    </Card>
  </Col>

  {/* OTHER OPS */}
  <Col span={4}>
    <Card
      style={{
        background: '#fff7e6',
        borderRadius: 10,
        textAlign: 'center'
      }}
      bodyStyle={{ padding: 12 }}
    >
      <div style={{ fontSize: 12, color: '#555', fontWeight: 600 }}>
        OTHER OPERATIONS
      </div>
      <div style={{ fontSize: 22, fontWeight: 'bold', color: '#fa8c16' }}>
        {qtyInfo?.prevOpOtherReported ?? 0}
      </div>
    </Card>
  </Col>

   <Col span={4}>
    <Card
      style={{
        background: '#fff1f0',
        borderRadius: 10,
        textAlign: 'center'
      }}
      bodyStyle={{ padding: 12 }}
    >
      <div style={{ fontSize: 12, color: '#555', fontWeight: 600 }}>
        CLUBBED QTY
      </div>
      <div style={{ fontSize: 22, fontWeight: 'bold', color: '#f5222d' }}>
        {qtyInfo?.clubbedQty ?? 0}
      </div>
    </Card>
  </Col>

  {/* AVAILABLE */}
  <Col span={4}>
    <Card
      style={{
        background: '#fff1f0',
        borderRadius: 10,
        textAlign: 'center'
      }}
      bodyStyle={{ padding: 12 }}
    >
      <div style={{ fontSize: 12, color: '#555', fontWeight: 600 }}>
        AVAILABLE QTY
      </div>
      <div style={{ fontSize: 22, fontWeight: 'bold', color: '#f5222d' }}>
        {qtyInfo?.availableQty ?? 0}
      </div>
    </Card>
  </Col>
</Row>

        <Row gutter={16} style={{ marginTop: 20 }}>
            <Col span={6}>
  <Form.Item
    label="Date"
    name="date"
    rules={[{ required: true, message: 'Date is required' }]}
  >
    <DatePicker style={{ width: '100%' }} />
  </Form.Item>
</Col>
          <Col span={6}>
            <Form.Item label="Operation" name="operation" rules={[{ required: true }]}>
              <Select placeholder="Select Operation" onChange={onOperationChange} showSearch
      optionFilterProp="children">
                {Object.values(spsaOperationEnum).map((op) => (
        <Option key={op} value={op}>
          {op}
        </Option>
      ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item label="Previous Operation" name="previousOperation" rules={[{ required: true }]}>
              <Select placeholder="Select Operation" onChange={onPreviousOperationChange} showSearch
      optionFilterProp="children">
               {Object?.values(spsaPrevOperationEnum)?.map((op) => (
        <Option key={op} value={op}>
          {op}
        </Option>
      ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item label="Lot Number" name="lotNumber" rules={[{ required: true }]} >
              <Select placeholder="Select Lot Number" onChange={onLotNoChange} showSearch
      optionFilterProp="children">
                {lotNumbers?.map(lot => (
                  <Option key={lot?.lotNumber} value={lot?.lotNumber}>
                    {lot?.lotNumber}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>


        </Row>

<Row gutter={16}>
  <Col span={6}>
                        <Form.Item
                          label="Product"
                          name="variant"
                          rules={[{ required: true }]}
                        >
                          <Select
                          onChange={(value) => onPrevOpOutputProductChange(value)}
                            showSearch
                            placeholder="Select Product"
                            optionFilterProp="children"
                          >
                            {
                                prevProduct.map(e => {
                                  return(
                                    <Option key={e.productId} value={e.productId}>{e.productName}</Option>
                                  )
                                })
                              }
                          </Select>
                        </Form.Item>
                      </Col>
  {OPERATION_FIELDS[selectedOperation]?.map((field: any) => (
    <Col span={6} key={field.name}>
      <Form.Item
        key={field.name}   
        label={field.label}
        name={field.name}
        rules={[
          { required: field.required, message: `${field.label} is required` }
        ]}
      >

        {field.type === 'input' && (
          <Input
    placeholder={`Enter ${field.label}`}
    value={form.getFieldValue(field.name)}
    disabled={field.name === 'lotName' || field.name === 'quality'}
    onChange={(e)=>{
        form.setFieldsValue({
            [field.name]:e.target.value
        })
    }}
/>
  // <Input
  //   placeholder={`Enter ${field.label}`}
  //   value={
  //     field.name === 'lotName'? prevOpData?.[0]?.variantName || '':
  //      field.name === 'quality'? prevOpData?.[0]?.quality || ''
  //      :
  //      field.name === 'remarks' ? prevOpData?.[0]?.remarks || '' 
  //       : undefined
  //   }
  //   disabled={field.name === 'lotName' || field.name === 'quality'}  
  //   onChange={(e) =>
  //     form.setFieldsValue({ [field.name]: e.target.value })
  //   }
  // />
)}

        {field.type === 'number' && (
          <Input
            type="number"
            placeholder={`Enter ${field.label}`}
            onChange={(e) =>
              form.setFieldsValue({ [field.name]: e.target.value })
            }
          />
        )}

       {field.type === 'textarea' && (
  // <TextArea
  //   placeholder={`Enter ${field.label}`}
  //   value={form.getFieldValue(field.name)}
  //   onChange={(e) =>
  //     form.setFieldsValue({ [field.name]: e.target.value })
  //   }
  // />
    <TextArea
        placeholder={`Enter ${field.label}`}
        autoSize={{ minRows: 2, maxRows: 4 }}
    />
)}

{field.name === 'countType' && (
  <Select
    placeholder="Select Count Type"
    value={form.getFieldValue('countType')}
    onChange={(value) => onCountTypeChange(value)} // ✅ UPDATED
  >
    {prevCountType.map((val) => (
     <Option key={val.out_count_type} value={val.out_count_type}>
  {val.out_count_type}
</Option>
    ))}
  </Select>
)}

{field.name === 'count' && (
  <Select
    placeholder="Select Count"
    value={form.getFieldValue('count')}
    onChange={(value) =>
      onCountChange(value)
    }
  >
 {prevCount.map((val, index) => (
  <Option key={index} value={val.outputCount}>
    {val.outputCount}
  </Option>
))}
  </Select>
)}

      </Form.Item>
    </Col>
  ))}
</Row>
        <Row gutter={16}>
          <Col >
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Col>

          <Col >
            <Button danger onClick={onReset}>
              Reset
            </Button>
          </Col>
        </Row>

      </Form>
    </Card>
  );
};

export default SpsaProductionOperationsForm;